import { createFileRoute } from '@tanstack/react-router'
import { AppointmentRouteComponent } from '@/components/appointment/AppointmentRouteComponent'
import { getHolidays } from '@/components/appointment/serverFn.ts'

export const Route = createFileRoute('/appointment/')({
	head: () => ({
		meta: [
			{ title: 'Schedule an Appointment | Wellview Care | South East Florida STD Testing & Treatment' },
			{
				name: 'description',
				content:
					'Ready to schedule an appointment with Wellview Care? Take the first step towards quality healthcare. Book an appointment for STD testing, treatment, or counseling services.',
			},
			{
				name: 'keywords',
				content: 'Schedule Appointment, STD Testing Appointment, HEP-C Consultation, HIV Consultation',
			},
		],
	}),
	loader: async () => await getHolidays(),
	component: RouteComponent,
})

function RouteComponent() {
	const holidays = Route.useLoaderData()
	return <AppointmentRouteComponent holidays={holidays} />
}
